import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ABAS } from '@/features/agenda/disponibilidade/abas'
import { Disponibilidade } from '@/features/agenda/disponibilidade/Disponibilidade'

export const Route = createFileRoute('/_app/app/agenda/config')({
  staticData: { crumb: { label: 'Disponibilidade' } },
  validateSearch: z.object({ aba: z.enum(ABAS).optional() }),
  component: Rota,
})

function Rota() {
  const { aba } = Route.useSearch()
  return <Disponibilidade aba={aba ?? 'semana'} />
}
